import { OrderPayablesProfile } from "../OrderPayablesProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: OrderPayablesProfile;
    panelHeader: Panel;
    sourceOrderPayablesProfile: DataSource;
}
